<div>
    <div class="w-full bg-white dark:bg-gray-900/10 mb-2 flex justify-between items-center py-2 px-2 rounded-lg"
        style="min-height: 50px;">
        <div class="w-full">
            <div class="p-2 rounded-lg w-24  flex items-center justify-center" [ngClass]="{ 
                    'bg-yellow-200 bg-opacity-80 text-yellow-700': status == 1,
                    'bg-blue-100 dark:bg-blue-900 bg-opacity-80 text-blue-700 dark:text-blue-300': status == 2,
                    'bg-green-200 dark:bg-green-900 bg-opacity-80 text-green-700 dark:text-green-300': status == 3,
                    'bg-red-100 dark:bg-red-900 bg-opacity-80 text-red-700 dark:text-red-300': status == 4,
                }">
                <p>{{
                    status === 1 ? "รออนุมัติ"
                    : status === 2 ? "อนุมัติ"
                    : status === 3 ? "เสร็จสิ้น"
                    : "ยกเลิก"
                    }}</p>
            </div>
        </div>
        <div class="flex justify-end items-center w-full gap-2">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
                class="p-2 px-4 rounded-lg border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-bold hover:border-amber-400 hover:text-amber-600 transition-all inline-flex items-center gap-1.5">
                <span class="material-icons text-[18px]">history</span>
                ดูประวัติ
            </button>
            <button class=" p-2 px-4  bg-green-400 text-white rounded-lg mr-2" (click)="onClickGenerateCode()"
                *ngIf="isDisableInput && status == 2">
                <p>สร้างรหัส</p>
            </button>
            <button class=" p-2 px-4  bg-yellow-400 hover:bg-yellow-500 transition text-white rounded-lg"
                (click)="onClickSaveCityparkingDiscount()" *ngIf="!isDisableInput">
                <p>บันทึก</p>
            </button>
        </div>
    </div>
    <div class="space-y-2 px-2">
        <!---------------- สถานที่ ------------------>
        <div class="flex justify-center item-center space-x-2">
            <div class="flex flex-col justify-center item-center w-full">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    สถานที่ให้บริการลานจอด
                </label>
                <div class="flex gap-2">
                    <app-input type="text" [valueIn]="siteName" [readOnly]="true"
                        class="flex-1 w-full dark:text-gray-200"></app-input>
                    <button type="button" *ngIf="!isDisableInput" (click)="showSelectProviderModal = true"
                        class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
                        เลือก
                    </button>
                </div>
            </div>
        </div>

        <!---------------- ชื่อบัตร + ประเภท ------------------>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
            <!-- ชื่อบัตรส่วนลด -->
            <div class="w-full md:w-1/2">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    ชื่อบัตรส่วนลด
                </label>
                <app-input class="w-full dark:text-gray-200 " [type]="'text'" [valueIn]="name" [validateName]="'name'"
                    [validateType]="'textNumber'" (validateOut)="isValidateTextNumber = $event"
                    [disabled]="isDisableInput" (valueOut)="name = $event" [placeholder]="'กรุณาใส่ชื่อบัตรส่วนลด'"
                    [max]="'30'">
                </app-input>
            </div>

            <!-- ประเภทบัตรส่วนลด -->
            <div class="w-full md:w-1/2 relative ">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    ประเภทบัตรส่วนลด
                </label>
                <app-select class="dark:text-gray-200 absolute top-6 right-0 w-full" style="z-index: 10;"
                    [valueIn]="selectType" [option]="typeOptions" [disabled]="isDisableInput"
                    (valueOut)="onChangeSelectType($event)" [placeholder]="'กรุณาเลือกประเภทบัตรส่วนลด'">
                </app-select>
            </div>
        </div>
        <!---------------- จำนวนราคา ------------------>
        <div class="w-full">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                {{ !selectType.value ? "ราคา" : "เปอร์เซ็น"}}
            </label>
            <div class="relative items-center">
                <label class="absolute right-4 top-2 text-gray-400 dark:text-gray-500 z-10">
                    {{ !selectType.value? "บาท": "%"}}
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'number'" [valueIn]="amount"
                    [disabled]="isDisableInput" (validateOut)="isValidateNumber = $event" (valueOut)="amount = $event"
                    [max]="'5'" [placeholder]="!selectType.value ? 'กรุณาใส่จำนวนราคา' : 'กรุณาใส่จำนวนเปอร์เซ็น'">
                    ></app-input>
            </div>
        </div>
        <!---------------- จำนวน Limit ------------------>
        <div class="w-full">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                ลดสูงสุด (ถ้ามี)
            </label>
            <div class="relative items-center">
                <label class="absolute right-4 top-2 text-gray-400 dark:text-gray-500 z-10">
                    บาท
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'number'" [valueIn]="limit"
                    [disabled]="isDisableInput" (validateOut)="isValidateNumber = $event" (valueOut)="limit = $event"
                    [max]="'5'" [placeholder]="'กรุณาใส่จำนวน Limit'">
                </app-input>
            </div>

        </div>
        <!---------------- จำนวนบัตร ------------------>
        <div class="w-full">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                จำนวนบัตร
            </label>
            <div class="relative items-center">
                <label class="absolute right-4 top-2 text-gray-400 dark:text-gray-500 z-10">
                    ชิ้น
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'number'" [valueIn]="qty"
                    [disabled]="isDisableInput" (validateOut)="isValidateNumber = $event" (valueOut)="qty = $event"
                    [max]="'5'" [placeholder]="'กรุณาใส่จำนวนบัตร'">
                </app-input>
            </div>
        </div>

        <!---------------- วันที่เริ่มต้น + สิ้นสุด ------------------>
        <div class="flex justify-center item-center space-x-2">
            <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    วันที่เริ่มต้น
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'date'" [valueIn]="startDate"
                    [disabled]="isDisableInput" (valueOut)="startDate = $event"
                    [placeholder]="'กรุณาเลือกวันที่เริ่มต้น'" *ngIf="!isDisableInput">
                </app-input>
                <!-- แสดงตัวหนังสืออย่างเดียว -->
                <div class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-200 dark:bg-gray-700"
                    *ngIf="isDisableInput">
                    <p class="text-gray-500 dark:text-gray-400">{{ startDate | date : "dd/MM/yyyy" }}</p>
                </div>
            </div>
            <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    วันที่สิ้นสุด
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'date'" [valueIn]="endDate"
                    [disabled]="isDisableInput" (valueOut)="endDate = $event" [placeholder]="'กรุณาเลือกวันที่สิ้นสุด'"
                    *ngIf="!isDisableInput">
                </app-input>
                <!-- แสดงตัวหนังสืออย่างเดียว -->
                <div class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-200 dark:bg-gray-700"
                    *ngIf="isDisableInput">
                    <p class="text-gray-500 dark:text-gray-400">{{ endDate | date : "dd/MM/yyyy" }}</p>
                </div>
            </div>
        </div>
        <!---------------- คำนำหน้าส่วนลด + สิทธิ์สูงสุด ------------------>
        <div class="flex justify-center item-center space-x-2 mt-2">
            <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    คำนำหน้าส่วนลด
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'text'" [valueIn]="codePrefix"
                    (valueOut)="codePrefix = $event" (validateOut)="isValidateTextNumber = $event"
                    [disabled]="isDisableInput" [max]="'3'"></app-input>
            </div>
            <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    สิทธิ์สูงสุด
                </label>
                <app-input class="block w-full dark:text-gray-200" [type]="'number'" [valueIn]="maxUsage"
                    (validateOut)="isValidateNumber = $event" (valueOut)="maxUsage = $event"
                    [disabled]="isDisableInput"></app-input>
            </div>
        </div>

        <!----------------- หมายเหตุ ------------------>
        <div class="w-full mt-2">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                หมายเหตุ
            </label>
            <textarea class="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md
                       focus:outline-none focus:ring focus:ring-yellow-300
                       bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200
                " placeholder="หมายเหตุ" [(ngModel)]="remark" [disabled]="isDisableInput">
            </textarea>
        </div>

    </div>

    <!-------------------------------------------------- ตาราง ---------------------------------->
    <div class="my-5" *ngIf="cityparkingDiscountByIdResponse?.details?.length !== ( 0 || null)">
        <div
            class="flex flex-col w-full bg-white dark:bg-gray-800 shadow py-2 m-2 rounded-xl border dark:border-gray-700">
            <div class="flex item-center gap-2 p-2 " style="min-height: 30px;">
                <button
                    class="bg-green-400 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center border border-green-400 px-4 py-2 rounded-md text-sm text-white gap-2 hover:bg-green-500 transition"
                    (click)="onExportToExcel()">
                    ดาวน์โหลด Excel
                </button>
            </div>
            <div class="w-full h-0.5 bg-gray-200 dark:bg-gray-700 my-2" *ngIf="!isDisableInput"></div>
            <div class="w-full overflow-x-auto">
                <table
                    class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm text-gray-800 dark:text-gray-200">
                    <thead class="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 uppercase text-xs">
                        <tr>
                            <th class="px-4 py-4 text-left">#</th>
                            <th class="px-4 py-4 text-left">ชื่อส่วนลด</th>
                            <th class="px-4 py-4 text-left">รหัสส่วนลด</th>
                            <th class="px-4 py-4 text-center">สถานะ</th>
                            <th class="px-4 py-4 text-left">วันที่สร้าง</th>
                            <th class="px-4 py-4 text-left">วันที่ใช้งาน</th>
                            <th class="px-4 py-4 text-center">สิทธิ์สูงสุด</th>
                            <th class="px-4 py-4 text-center">ใช้งานแล้ว</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800">
                        <tr *ngFor="let c of cityparkingDiscountByIdResponse?.details; let i = index"
                            class="hover:bg-gray-50 dark:hover:bg-gray-700 transition cursor-pointer">
                            <td class="px-4 py-6" *ngIf="i+1 <= 100">{{ i + 1 }}</td>
                            <td class="px-4 py-6" *ngIf="i+1 <= 100">{{ c.name }}</td>
                            <td class="px-4 py-4 flex items-center gap-1" *ngIf="i+1 <= 100">
                                <label class="w-40">{{ c.code }}</label>
                                <div class="w-4 h-4 cursor-pointer" (click)="onClickCopyCode(c.code)">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpElEQVR4nO3csWoUURQG4IOKWqgPoJYimE723lEECTaCkjaPYOcaNPes5T6E4otYWFpFsYqBgLi5J0HUykpUNNXKmE52N7PZyZxzZv4f/nJ2Z77cnZk9S4YIQRAEQRCktRnuLZ/lHNZSju84x58scXzcTRL3k8SNgfQK6kIGo+Iy57DVBO5E8Bx+p93iLnVgJW9pIXcGm3NY00buBHYqz8kGkFuPnST+0AGNvzqFzWqrt7h9yB/5D0tcobaElaAP3rtD2KwI3SlsVobuDDYbgO4ENhuBbj02G4JuNTYbg24tNhuENo89a9TpDboM7xR3zH2DPGzU6RHaHHaVUadX6KrYjfx4UGXUaQ2aP12/WCu2xA2yMOo0B53j03mPcxZ2+bMYWRh1WoNOEvdL7DpXdi2YM9+8woEtsi07KaAF0KSNA2jxV0ALoEkbB9Dir4AWQJM2DqDFXwEtgCZtHECLvwJaAE3aOIAWfwW0AJq0cQAt/gpoATRp4wBa/BXQAmjSxgG0+CugBdCkjQNo8VdAC6BJGwfQ4q+AFkCTNk7roPnDrfOWHozCtTd8NwH9ROJVD4/64SM25fDWBPR6Dvcmbbue4yNtpDo6kN5DE9Cc4/NJ2/ZHV86kHN5rQy3UHDaH20unTUAnCZ+Hr5dPTfuv2+QVO4fNxx9vXjp25KrQ/7B344Npr9EvV/ZO7JfnOusXyIP9C2/K00UjK3lu6By/Trv7QCpkvhURXq2OV09q77PLzP3Ry/HZcEwntPfbXY50nsvhZX9UXNDed1dZ4MLyrXwywrS7EeS/LH4lD19YwgvOvfuDvRvXhttL57SPyWS0b7e4xpLlaOMwoP2VLMf6Nzm2NOpcJBh1NhSMOhsKRp0NBqPOBoNRJ4IgCIIgCIIgCLUjfwGnfrd/uiaR+AAAAABJRU5ErkJggg=="
                                        alt="copy" class="dark:invert">
                                </div>
                            </td>
                            <td class="px-4 py-6 text-center" *ngIf="i+1 <= 100">
                                <span [ngClass]="
                                    c.activate
                                        ? 'bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-300'
                                        : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                                    " class="px-3 py-2 rounded-lg text-sm font-semibold">
                                    {{ c.activate ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
                                </span>
                            </td>

                            <td class="px-4 py-6" *ngIf="i+1 <= 100">{{ c.createDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="px-4 py-6" *ngIf="i+1 <= 100">{{ c.activateDate | date: 'dd/MM/yyyy' }}</td>
                            <td class="px-4 py-6 text-center" *ngIf="i+1 <= 100">{{ c.maxUsage }}</td>
                            <td class="px-4 py-6 text-center" *ngIf="i+1 <= 100">{{ c.usageCount }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>


<!--------------------------------------------- Modal ------------------------------------->
<!----------- Modal Selected Site ID -------------------->
<div *ngIf="showSelectProviderModal" class="fixed inset-0 z-20 flex items-start top-0 justify-center bg-black/60 pt-10">
    <div
        class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
        <!-- ปุ่มปิด -->
        <button (click)="showSelectProviderModal = false"
            class="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-red-500 text-4xl font-bold">
            &times;
        </button>

        <h2 class="text-xl font-semibold mb-4 text-gray-800 dark:text-gray-200">เลือกผู้ให้บริการลานจอด</h2>

        <!-- ค้นหา -->
        <input type="text" [(ngModel)]="searchProvider" placeholder="ค้นหาชื่อผู้ให้บริการ..."
            class="w-full px-3 py-2 mb-4 border dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />

        <!-- รายการ -->
        <ul class="max-h-64 overflow-y-auto space-y-2">
            <li *ngFor="let provider of filteredProviders()" (click)="selectProvider(provider)"
                class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200">
                <div class="font-medium">{{ provider.name }}</div>
                <div class="text-sm text-gray-500 dark:text-gray-400">{{ provider.address }}</div>
            </li>
        </ul>
    </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && discountEntityId"
  [entityType]="activityEntityTypes.CityParkingDiscount"
  [entityId]="discountEntityId"
  title="ประวัติส่วนลด"
  [subtitle]="'#' + discountEntityId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>